module.exports = __webpack_public_path__ + "images/9c5a5cf300d855f7588627095423b2a4.png";